import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import whyus from "assets/images/whyus_bg.png";

import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

function Information() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 2, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="YOUR SHOW, OUR PROMISE"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Why Choose MakeMyShows
          </MKTypography>
          <MKTypography variant="body1" color="text">
            Discover why MakeMyShows is your trusted partner for unforgettable events.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container item xs={11} spacing={3} sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={whyus}
                icon="touch_app"
                title={
                  <>
                    Easy, Hassle-Free
                    <br />
                    Booking
                  </>
                }
                description="Book your artist in just a few steps."
              />
              <RotatingCardBack
                image={bgBack}
                title="Booking Made Simple"
                description="From browsing artists to final confirmation, everything is smooth, quick, and transparent."
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: "Book Now",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="book_online"
                  title="Quick & Easy Booking"
                  description="Experience the most reliable and fast way to book top artists for any occasion. MakeMyShows provides a streamlined process for booking, making your event planning efficient and stress-free."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="currency_rupee_icon"
                  title="Transparent Pricing"
                  description="MakeMyShows stands for clear pricing—no hidden charges or surprise fees. Enjoy straightforward rates and honest deals throughout your entire booking journey."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="celebration"
                  title="Complete Event Management"
                  description="From your initial inquiry to the last applause, our dedicated team ensures every aspect of the event is perfectly managed. Enjoy professional artist coordination and flawless event execution."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="currency_exchange"
                  title="Hassle-Free Cancellations"
                  description="Plans can change, and MakeMyShows makes it easy to update or cancel bookings. Benefit from our simple cancellation policy for maximum flexibility with minimal inconvenience."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} ml={4} sx={{ mt: { xs: 0, md: 6 } }}>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              icon="on_device_training"
              title="Backup Solutions On Demand"
              description='"The event never stops!" If anything unpredictable happens, MakeMyShows will quickly provide backup artists, ensuring your show proceeds smoothly without interruptions."'
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              icon="payments"
              title="Secure Payments"
              description="Your financial safety matters. MakeMyShows uses advanced payment gateways to protect every transaction, so your details remain confidential and secure—giving you peace of mind for every event."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              icon="support_agent"
              title="24/7 Support"
              description="Enjoy round-the-clock customer assistance. Our friendly support team is always available to resolve queries and provide assistance through every step of your booking and event journey."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
